import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-next-offers-presentation-dialog',
  templateUrl: './next-offers-presentation-dialog.component.html',
  styleUrls: []
})
export class NextOffersPresentationDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
